import { tripRetrieveResource } from '@api/vendor.service'

export function createStore(parameters) {
  return {
    namespaced: true,
    state: {
      trip: {},
      load: false,
    },
    actions: {
      async getTrip({ commit, state }, payload) {
        console.log(state.load);
        if (state.load) return
        state.load = true
        const { data } = (await tripRetrieveResource.execute({ label: payload }))
        state.load = false
        commit('SET_ITEM', data.props)
      },
    },
    mutations: {
      SET_ITEM(state, payload) {
        state.trip = payload
      },
    },
  }
}
